import { render, staticRenderFns } from "./Concourses.vue?vue&type=template&id=5521a350"
import script from "./Concourses.vue?vue&type=script&lang=ts"
export * from "./Concourses.vue?vue&type=script&lang=ts"
import style0 from "./Concourses.vue?vue&type=style&index=0&id=5521a350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports